export default {
  isLocalStorageSupported () {
    try {
      const item = "lsTest";

      window.localStorage.setItem(item, item);
      window.localStorage.removeItem(item);
      return true;
    } catch (e) {
      return false;
    }
  },

  setItem (key, item) {
    window.localStorage.setItem(key, item);
  },

  getItem (key) {
    return window.localStorage.getItem(key);
  },

  removeItem (key) {
    window.localStorage.removeItem(key);
  },

  clear () {
    window.localStorage.clear();
  }
};
